import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Link, useNavigate } from "react-router-dom";
import { store } from "../stores/Store";
import { formatBRL } from "../utils";
import { ProdutoCategoria, Produto } from "../types/store";

export const Loja: React.FC = observer(() => {
  const products = store.getProductsByCategory(ProdutoCategoria.LOJA);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    store.loadLoja();
  }, []);

  const handleAddToCart = (e: React.MouseEvent, product: Produto) => {
    e.preventDefault();
    store.addToCart(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCheckout = () => {
    navigate("/carrinho");
  };

  return (
    <div className="container-fluid bg_branco">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            {products.length === 0 ? (
              <div className="no-products-message">Sem produtos no momento</div>
            ) : (
              <ul className="ctn_products ctn_li_25">
                {products.map((product) => (
                  <li key={product.id}>
                    <Link className="img_link" to={`/product/${product.id}`}>
                      <div className="more"></div>
                      <img src={product.fotoCapaUrl} alt={product.nome} />
                    </Link>

                    <h2 className="titulo_20 text-center">{product.nome}</h2>

                    <h3 className="preco titulo_25 titulo_700 txt_cor-id-1 text-center mg-bt_10">
                      {product.desconto > 0 && (
                        <span className="desconto">
                          {formatBRL(product.preco)}
                        </span>
                      )}
                      {formatBRL(product.preco - product.desconto)}
                    </h3>

                    {product.quantidadeEstoque > 0 ? (
                      <button
                        className="bt bt_center bt_carrinho"
                        onClick={(e) => handleAddToCart(e, product)}
                      >
                        Adicionar
                      </button>
                    ) : (
                      <div
                        style={{
                          color: "#dc3545",
                          fontWeight: "bold",
                          textAlign: "center",
                          marginTop: 8,
                        }}
                      >
                        ESGOTADO
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            )}
            {/* Modal Popup */}
            {showModal && (
              <div className="custom-modal-overlay">
                <div className="custom-modal">
                  <p className="custom-modal-title">
                    Produto adicionado ao carrinho!
                  </p>
                  <div className="custom-modal-actions">
                    <button className="bt bt_center" onClick={handleCloseModal}>
                      Continuar Comprando
                    </button>
                    <button
                      className="bt bt_center bt_carrinho"
                      onClick={handleCheckout}
                    >
                      Finalizar Pedido
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
